module.exports = __webpack_public_path__ + "img/join_banner_wrap.ecadc61.ecadc61d.png";